import { Card } from "antd";

// components
import LimitDropdown from "./limit-dropdowm";
import { getModeOfLocation } from "@src/util/fb-exploration/get-mode-of-location";
import { QueryLimitGroupProps } from "@src/types/query-builder-firebase";

export default function LimitGroup({ title, query, isQueryPresent, updateQuery }: QueryLimitGroupProps) {
  const { isViewMode } = getModeOfLocation();
  return (
    <Card size="small" title={title} className="h-full">
      <LimitDropdown
        query={query}
        limit={query.limit || 100}
        disabled={!isQueryPresent || !!isViewMode}
        updateQuery={updateQuery}
      />
    </Card>
  );
}
